export * from './getColor'
